import type { ProductUnsecuredLoanConfig } from '../../@types/context/product-unsecured-loan-config.types';

export const unsecuredLoansDkConfig: Omit<
  ProductUnsecuredLoanConfig,
  'fields'
> = {
  rates: {
    min: 9.0,
    low: 3.6,
    mid: 12,
    high: 20.95,
    establish: 3.0,
    monthly_fee: 0,
    interest_rate: 0.0,
  },
  config: {
    amount: {
      min: 10_000,
      max: 500_000,
      default: 250_000,
      step: 5_000,
    },
    duration: {
      min: 1,
      max: 15,
      default: 12,
      step: 1,
    },
  },
};
